import styled from 'styled-components';

import {
  itemsPerRowCss,
  ItemsPerRowProps,
  multipleChoiceItemStatusCss,
  MultipleChoiceItemStatusProps,
  optionSize,
  OptionSizeProps,
} from './multiple-choice.style';
import { flexSpaceBetweenCss } from 'approot/shared/styles/flex.style';
import { grey1, grey5, grey9 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing16, spacing4 } from 'approot/shared/styles/spacing.style';

type MultipleChoiceStyleProps = {
  $isActive?: boolean;
  $isText?: boolean;
} & MultipleChoiceItemStatusProps &
  OptionSizeProps &
  ItemsPerRowProps;

export const MultipleChoiceSelectedAnswerTile = styled.div<MultipleChoiceStyleProps>`
  ${optionSize}
  ${itemsPerRowCss}
  ${flexSpaceBetweenCss}

  background-color: ${grey1};
  border: 1px solid ${grey5};
  color: ${grey9};
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  border-radius: ${rem(borderRadius8)};
  padding: ${({ $isText }) => ($isText ? rem(spacing16) : rem(spacing4))};
  position: relative;

  ${multipleChoiceItemStatusCss}
`;
